export const PAGE_OPENED = 'page/PAGE_OPENED';

export const pageOpened = payload => ({
  type: PAGE_OPENED,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/page-opened.js